
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/new-drivers",
      function () {
        return require("private-next-pages/guides/new-drivers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/new-drivers"])
      });
    }
  